import React, { FC } from 'react';
import { NavLawyerProfile } from './NavLawyerProfile';
import { useUser } from '../../../user/useUser';

export const NavUserLawyer: FC = () => {
  const { currentUser } = useUser();

  if (!currentUser.lawyerId) return null;

  return (
    <NavLawyerProfile
      pictureUrl={currentUser.pictureUrl}
      href={`/p/avocat/${currentUser.lawyerId}?source=nav_dropdown`}
      name={currentUser.isExpired ? currentUser.name : ''}
    />
  );
};
